import * as actionTypes from './actionTypes'

import languageTestApi from './../../api/languageTest';

const languageTestRequest = () => ({
  type: actionTypes.LANG_TEST_REQUEST
});

const languageTestReceive = data => ({
  type: actionTypes.LANG_TEST_RECEIVE,
  data,
});

const languageTestError = error => ({
  type: actionTypes.LANG_TEST_ERROR,
  error,
});

const languageTestFetch = () => dispatch => {
  dispatch(languageTestRequest());
  return languageTestApi.getLangTest().then(data => dispatch(languageTestReceive(data))).catch(error => dispatch(languageTestError(error)));
};

const languageTestShouldFetch = state => {
  const tasksState = state;
  if (tasksState.isFetching) {
    return true;
  }
  if (!tasksState.data) {
    return false;
  }
  return tasksState.didInvalidate;
};

export const languageTestFetchIfNeeded = () => (dispatch, getState) => {
  if (!languageTestShouldFetch(getState().tasks)) {
    return Promise.resolve();
  }
  return dispatch(languageTestFetch());
};

export const languageTestSet = data => (dispatch) => {
  dispatch(languageTestRequest());
  return languageTestApi.nextStep(data).then(data => dispatch(languageTestReceive(data))).catch(error => dispatch(languageTestError(error)));
};



// WEBPACK FOOTER //
// ./src/store/languageTest/actions.js